import { CONNECTIONS } from './constant';
import { ConnectionModelState } from './reducers';
import { createSelector } from 'reselect';

const selector = (state: Record<string, ConnectionModelState>) =>
    state?.[CONNECTIONS.toLowerCase()];

export default createSelector([selector], (connections) => connections);
